document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("dispatch-estimate");
    if (!container) return;

    const country = container.dataset.country;
    const now = new Date();
    const cutoffHour = 12;

    // ---------------------------------
    // VIC Public Holidays (static list)
    // ---------------------------------
    // Dates are YYYY-MM-DD (Melbourne / Victoria).
    // Note: AFL Grand Final Friday can vary; add it here if your ops team observes it.
    const PUBLIC_HOLIDAYS = [
        // ---- 2026 ----
        "2026-01-01", // New Year's Day
        "2026-01-26", // Australia Day
        "2026-03-09", // Labour Day (VIC)
        "2026-04-03", // Good Friday
        "2026-04-06", // Easter Monday
        "2026-04-25", // ANZAC Day
        "2026-06-08", // King's Birthday
        "2026-11-03", // Melbourne Cup Day
        "2026-12-25", // Christmas Day
        "2026-12-28", // Boxing Day (observed, since 26th is Sat)

        // ---- 2027 ----
        "2027-01-01", // New Year's Day
        "2027-01-26", // Australia Day
        "2027-03-08", // Labour Day (VIC)
        "2027-03-26", // Good Friday
        "2027-03-29", // Easter Monday
        "2027-04-26", // ANZAC Day (observed, since 25th is Sun)
        "2027-06-14", // King's Birthday
        "2027-11-02", // Melbourne Cup Day
        "2027-12-27", // Christmas Day (observed, since 25th is Sat)
        "2027-12-28", // Boxing Day (observed)

        // ---- 2028 ----
        "2028-01-03", // New Year's Day (observed, since 1st is Sat)
        "2028-01-26", // Australia Day
        "2028-03-13", // Labour Day (VIC)
        "2028-04-14", // Good Friday
        "2028-04-17", // Easter Monday
        "2028-04-25", // ANZAC Day
        "2028-06-12", // King's Birthday
        "2028-11-07", // Melbourne Cup Day
        "2028-12-25", // Christmas Day
        "2028-12-26"  // Boxing Day
    ];

    // -------------------------
    // Helpers
    // -------------------------
    const formatISO = (date) => date.toISOString().split("T")[0];

    const isWeekend = (date) => {
        const d = date.getDay();
        return d === 0 || d === 6;
    };

    const isPublicHoliday = (date) => PUBLIC_HOLIDAYS.includes(formatISO(date));

    const isNonBusinessDay = (date) => isWeekend(date) || isPublicHoliday(date);

    const nextBusinessDay = (date) => {
        const d = new Date(date);
        do {
            d.setDate(d.getDate() + 1);
        } while (isNonBusinessDay(d));
        return d;
    };

    const addBusinessDays = (date, days) => {
        const d = new Date(date);
        let added = 0;

        while (added < days) {
            d.setDate(d.getDate() + 1);
            if (!isNonBusinessDay(d)) added++;
        }

        return d;
    };

    const format = (date, simple = false) => {
        if(simple) {
            return date.toLocaleDateString(undefined, {
                day: "numeric",
                month: "short"
            });
        }
        return date.toLocaleDateString(undefined, {
            weekday: "short",
            day: "numeric",
            month: "short"
        });
    }

    // -------------------------
    // Order Placed
    // -------------------------
    const orderPlaced = new Date(now);

    // -------------------------
    // Dispatch Calculation
    // -------------------------
    let dispatchDate = new Date(now);

    // If after cutoff OR non-business day -> next business day
    if (now.getHours() >= cutoffHour || isNonBusinessDay(now)) {
        dispatchDate = nextBusinessDay(dispatchDate);
    }

    // -------------------------
    // Delivery Calculation
    // -------------------------
    const deliveryDays = country === "AU" ? 2 : 7;
    const deliveryDate = addBusinessDays(dispatchDate, deliveryDays);

    // -------------------------
    // Render
    // -------------------------
    const orderedEl = container.querySelector('[data-date="ordered"]');
    const dispatchEl = container.querySelector('[data-date="dispatch"]');
    const deliveryEl = container.querySelector('[data-date="delivery"]');
    const deliveryElText = container.querySelector('[data-date="delivery-text"]');

    if (orderedEl) orderedEl.textContent = format(orderPlaced);
    if (dispatchEl) dispatchEl.textContent = format(dispatchDate);
    if (deliveryEl) deliveryEl.textContent = format(deliveryDate);
    if (deliveryElText) deliveryElText.textContent = format(deliveryDate, true);
});